/**
 * 全局语言文本管理
 */
import { getLanguage, setLanguage } from './lang'
import { request } from './request'

let fulltextData = {}
let loadingPromise = null

/**
 * 获取语言文本
 * @param {string} key - 文本键名
 * @param {string} defaultValue - 默认值（如果找不到对应的文本）
 * @returns {string} 对应的文本
 */
export function getText(key, defaultValue = '') {
    if (!key) return defaultValue
        // 支持嵌套键，如 'home.title' 或 'a.b.c'
    const keys = key.split('.')
    let value = fulltextData
    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k]
        } else {
            return defaultValue
        }
    }
    return value || defaultValue
}

/**
 * 加载语言文本
 * @param {string} lang - 语言代码，如果不传则使用当前语言
 * @returns {Promise} 加载Promise
 */
export function loadFulltext(lang) {
    // 如果正在加载，返回同一个Promise
    if (loadingPromise) {
        return loadingPromise
    }

    const language = lang || getLanguage()

    // 如果指定了语言，临时设置语言（因为拦截器会读取 getLanguage）
    const originalLang = getLanguage()
    if (lang && lang !== originalLang) {
        setLanguage(lang)
    }

    loadingPromise = request({
            url: '/index/fulltext',
            method: 'get'
        })
        .then(res => {
            if (res.code === 0 || res.repCode === '0000' || res.code === 90000) {
                fulltextData = res.data || {}
            } else {
                console.error('Failed to load fulltext:', res)
                fulltextData = {}
            }
            // 恢复原始语言设置
            if (lang && lang !== originalLang) {
                setLanguage(originalLang)
            }
            loadingPromise = null
            return fulltextData
        })
        .catch(error => {
            console.error('Error loading fulltext:', error)
            fulltextData = {}
                // 恢复原始语言设置
            if (lang && lang !== originalLang) {
                setLanguage(originalLang)
            }
            loadingPromise = null
            return {}
        })

    return loadingPromise
}

/**
 * 重新加载语言文本（语言切换时使用）
 * @param {string} lang - 语言代码
 * @returns {Promise} 加载Promise
 */
export function reloadFulltext(lang) {
    loadingPromise = null
    return loadFulltext(lang)
}

/**
 * 获取当前语言文本数据
 * @returns {object} 当前语言文本数据
 */
export function getFulltextData() {
    return fulltextData
}